export default __webpack_public_path__ + "images/375dfc64d1e1a1782a4f1d9aa0fdc4a3-completing_daily_tasks_at_home.svg";